import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { Group } from './master-consulta-grupos-models';

const BASE_PATH = environment.basePath;
const headers = new HttpHeaders({ "Content-Type": "application/json" });

@Injectable({
  providedIn: 'root'
})
export class MasterConsultaGruposService {

  constructor(private _$http: HttpClient) { }
  

  getGroups(): Observable<any> {
    return this._$http.get<any>(`${BASE_PATH}/bff/master/investmentGroup/findById`);
  }
  duplicateGroup(group: Group){
    return this._$http.post<Group>(`${BASE_PATH}/bff/master/investmentGroup/duplicate/${group.id}`, group)
  }
  deleteGroup(id: string): Observable<Group>{
    return this
           ._$http
           .delete<Group>(`${BASE_PATH}/bff/master/investmentGroup/delete/${id}`);
  }
  groupDeletionLog(log: any){
    // return this
    //       ._$http
    //       .post<any>(`${BASE_PATH}/bff/log`,{log});
  }
  groupDuplicationLog(log: any){
    // return this
    //       ._$http
    //       .post<any>(`${BASE_PATH}/bff/log`,{log});
  }
}
